import skodaConfirmation from '../../media/skoda-confirmation.png';
import skodaLogo from '../../media/skoda-logo.svg';

const CAR_MODEL_ID = 62;
// Configuration spécifique Skoda
export const skodaConfig = {
  // Configuration de l'application
  app: {
    carModelId: CAR_MODEL_ID,
    maxCommentLength: 200,
    sessionStorageKey: 'rdv_live',
    maxWorkingDaysAhead: 10,
  },

  // Images
  images: {
    logo: skodaLogo,
    confirmation: skodaConfirmation,
  },

  // API Endpoints
  api: {
    calendar: `/calendar_for_business_center/${CAR_MODEL_ID}`,
    saveAppointment: 'save_appointment_for_business_center/',
  },

  // Url externes
  urlExternes: {
    rgpd: 'https://www.skoda.fr/informations/mentions-legales',
  },

  // Messages
  messages: {
    loading: 'Chargement des disponibilités...',
    loadingAvailabilities: 'Chargement des disponibilités...',
    errorLoading: 'Erreur lors du chargement des données',
    errorAppointment:
      'Nous rencontrons actuellement un problème lors de la prise de votre rendez-vous. Nous vous prions de bien vouloir réessayer ultérieurement. Nous nous excusons pour ce désagrément.',
    errorTicketNotFound: 'Rendez-vous créé, mais ticket introuvable',
    errorDataLoading: 'Impossible de charger les données.',
    errorZendeskIdMissing:
      "Impossible d'enregistrer votre rendez-vous,  merci de prendre contact avec votre conseiller automobile.",
    errorCommentInvalid:
      'Erreur : Le commentaire contient des caractères non autorisés. Veuillez modifier votre message.',
    confirmationTitle: 'Merci pour votre confiance !',
    confirmationSubtitle: 'Votre rendez-vous est confirmé',
    returnToMenu: 'Retour au menu',
    returnToMainMenu: 'Retour au menu principal',
    retry: 'Réessayer',
    dateLabel: '',
    mainTitle: 'Réservez votre rendez-vous téléphonique avec un conseiller connecté',
    timeSelectionTitle: 'Sélectionnez un créneau horaire',
    commentPlaceholder:
      'Ajoutez un commentaire à transmettre à votre conseiller',
    confirmButton: 'Confirmer ma réservation',
    breadcrumbDate: 'Date',
    breadcrumbSlot: 'Créneau',
    breadcrumbSeparator: ' > ',
    rgpdText:
      'Pour en savoir plus sur la gestion de vos données personnelles et pour connaître vos droits et les exercer, reportez-vous à la ',
    rgpdLinkText: 'Charte des Données Personnelles',
    testConfirmation: 'Tester la confirmation',
    resetToToday: "Réinitialiser à aujourd'hui",
    dateSimulator: 'Simulateur de date',
  },

  // Design - Palette de couleurs complète pour Skoda
  design: {
    name: 'Skoda',
    logo: skodaLogo,
    fontFamily: 'Skoda',

    // Poids de la police par type de texte
    fontWeight: {
      title: '400', // Titre principal (bold)
      subtitle: '600', // Sous-titre (semi-bold)
      body: '400', // Texte normal
      button: '600', // Boutons (semi-bold)
      label: '500', // Labels (medium)
      caption: '400', // Texte secondaire
      calendarDay: '600', // Jours du calendrier (semi-bold)
      timeSlot: '600', // Créneaux horaires (semi-bold)
      timeSlotSelected: '900', // Créneaux horaires sélectionnés (black)
      calendarDate: '400',
    },

    // Taille de la police par type de texte
    fontSize: {
      title: '28px', // Titre principal
      subtitle: '16px', // Sous-titre
      body: '14px', // Texte normal
      button: '14px', // Boutons
      label: '12px', // Labels
      caption: '11px', // Texte secondaire
      calendarDay: '14px', // Jours du calendrier
      timeSlot: '14px', // Créneaux horaires
    },

    // Couleurs principales
    primaryColor: '#000E26', // Bleu foncé Skoda
    secondaryColor: '#ffffff', // Blanc
    accentColor: '#2E7D32', // Vert foncé Skoda

    // Couleurs de texte
    textPrimary: '#161718', // Texte principal (vert foncé)
    textSecondary: '#161718', // Texte secondaire
    textRgpdColor: '#707070', // Texte RGPD
    textDisabled: '#F8F8F8', // Texte désactivé
    textPlaceholder: '#000', // Texte placeholder

    // Couleurs de fond
    backgroundPrimary: '#ffffff', // Fond principal
    backgroundSecondary: '#f8f9fa', // Fond secondaire
    backgroundHover: '#e8f5e8', // Fond au survol (vert clair)
    backgroundSelected: '#4BA82E', // Fond sélectionné (vert Skoda)

    // Couleurs des bordures
    borderPrimary: 'none', // Bordure principale
    borderSecondary: '#cccccc', // Bordure secondaire
    borderFocus: '#4BA82E', // Bordure focus (vert Skoda)

    // Couleurs d'état
    successColor: '#4BA82E', // Vert succès (couleur Skoda)
    errorColor: '#dc3545', // Rouge erreur
    warningColor: '#ffc107', // Jaune avertissement
    infoColor: '#17a2b8', // Bleu info

    // Couleurs des boutons
    buttonPrimary: '#78F9AE', // Bouton principal (vert Skoda)
    buttonPrimaryHover: '#95FEC7', // Bouton principal survol
    buttonSecondary: '#ffffff', // Bouton secondaire
    buttonSecondaryHover: '#f8f9fa', // Bouton secondaire survol
    buttonDisabled: '#cccccc', // Bouton désactivé

    // Rayon des bordures des boutons
    buttonBorderRadius: '26pt', // Rayon des bordures des boutons
    calendarDayBorderRadius: '0px', // Rayon des bordures des jours du calendrier
    timeSlotBorderRadius: '0px', // Rayon des bordures des créneaux horaires

    // Couleurs du calendrier
    calendarHeader: '#666666', // En-tête calendrier
    calendarDay: '#000E26', // Jour calendrier (vert foncé)
    calendarDayHover: '#78F9AE', // Jour calendrier survol (vert clair)
    calendarDaySelected: '#4BA82E', // Jour sélectionné (vert Skoda)
    calendarDayDisabled: '#F8F8F8', // Jour désactivé

    // Couleurs des créneaux horaires
    timeSlot: '#ffffff', // Créneau horaire
    timeSlotHover: '#59E099', // Créneau survol (vert clair)
    timeSlotSelected: '#59E099', // Créneau sélectionné (vert Skoda)
    timeSlotDisabled: '#F8F8F8', // Créneau désactivé
    timeSlotTextDisabled: '#838383', // Texte créneau désactivé
  },

  // Configuration des slugs
  slugs: {
    skodaFiscale: 'skoda-bc',
  },

  // Configuration des marques RDV
  marqueRdv: {
    bc: 'marquerdv_skodabc',
  },

  // Données de test
  testData: {
    confirmationDate: '18 / 09 / 2025',
    confirmationTime: '12 : 30',
  },
};
